export function keyBy(array, fn = (v) => v) {
    const output = {}
    for (const item of array) {
        output[fn(item)] = item
    }
    return output
}
